import { validState } from './states';
import { isValueFalsey } from '../../internal';
export const resolveValidationState = (helpMessage, hasError, errorMessage, isSuccessful, successMessage) => {
  const newValidState = {
    ...validState
  };
  if (hasError && !isValueFalsey(errorMessage)) {
    newValidState.type = 'error';
    newValidState.message = errorMessage;
    newValidState.isValid = false;
    newValidState.messageKey = 'hasError';
    return newValidState;
  }
  if (isSuccessful && !isValueFalsey(successMessage)) {
    newValidState.type = 'success';
    newValidState.message = successMessage;
    newValidState.isValid = true;
    newValidState.messageKey = 'isSuccessful';
    return newValidState;
  }
  if (helpMessage) {
    newValidState.type = 'msg';
    newValidState.message = helpMessage;
    return newValidState;
  }
  return newValidState;
};